<script lang="ts">
    import ButtonGroup from "../Elements/ButtonGroup.svelte";
    import {Envelope, MapPin, Phone} from "svelte-heros";
    import Map from "$components/Sections/Map.svelte";
    import { t } from '$lib/translations';
    import LocationTiles from "$components/Elements/LocationTiles.svelte";
    export let section: Section;
    export let index: number;

</script>


{#if section.hasMap}
    <Map {section} {index} />
{:else}
    <div class="bg-white" >
        <div class="px-6 py-12 sm:px-6 sm:py-32 lg:px-8">
            <div class="mx-auto max-w-2xl lg:text-center">
                {#if index === 0}
                    <h1 class="text-5xl font-bold font-display tracking-tight text-gray-900 sm:text-6xl">{section.title}</h1>
                {:else }
                    <h2 class="text-4xl font-bold font-display tracking-tight text-gray-900 sm:text-5xl">{section.title}</h2>
                {/if}

                <p class="mx-auto mt-6 max-w-xl text-lg leading-8 text-gray-600">{section.description}</p>

                {#if section.cta}
                    <div class="mt-10 flex items-center lg:justify-center gap-x-6">
                        <ButtonGroup buttons={section.cta} />
                    </div>
                {/if}
            </div>
        </div>
    </div>
{/if}
<div class="bg-white py-24 sm:py-32" class:pt-8={section.hasMap} class:sm:pt-0={section.hasMap}>
    <div class="mx-auto max-w-7xl px-6 lg:px-8">
        <div class="mx-auto max-w-2xl space-y-16 divide-y divide-gray-100 lg:mx-0 lg:max-w-none">
            <div class="grid grid-cols-1 gap-x-8 gap-y-10 lg:grid-cols-2">
                <LocationTiles />
            </div>
        </div>
    </div>
</div>
